import {
  focusOn,
  widgetClose,
  widgetOpen,
  isMobile,
  isIOS,
  fixedBodyStyleAddAll,
  fixedBodyStyleRemoveAll,
  updateCatalogOverflowState,
  isBodyFixed,
} from '../../../resources/scripts/components/c-common';

function controlOpen(el) {
  const container = el.querySelector('.js-hotel-search-control-container');
  container.classList.add('open');
}

function controlClose(el) {
  const container = el.querySelector('.js-hotel-search-control-container');
  container.classList.remove('open');
}

function addLink(el, link) {
  const buttonLink = el.querySelector('.js-hotel-search-control-link');
  buttonLink.style.display = 'flex';
  buttonLink.href = link;
}

function controlCloseAll(el) {
  const containers = el.querySelectorAll('.js-hotel-search-control-container');
  containers.forEach((container) => {
    container.classList.remove('open');
  });
}

const widget = window.document.querySelector('.js-hotel-search');

function hotelSearchBackdropAdd() {
  const hotelSearch = window.document.querySelector('.hotel-search');
  if (hotelSearch) {
    hotelSearch.classList.add('backdrop');
  }

  const header = window.document.querySelector('.header');
  if (header) {
    header.classList.remove('header--visible');
  }

  if (isMobile()) {
    if (isIOS) {
      fixedBodyStyleAddAll();
      const input = hotelSearch.querySelector('input[type="text"], input[type="search"]');
      if (input) {
        input.focus();
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, 100);
      }
    } else {
      fixedBodyStyleAddAll();
    }
  }
}

function hotelSearchBackdropRemove() {
  const hotelSearch = window.document.querySelector('.hotel-search');
  if (hotelSearch) {
    hotelSearch.classList.remove('backdrop');
  }
  if (isMobile()) {
    fixedBodyStyleRemoveAll();
  }
}

function closeHotelSearchWidget() {
  const controls = window.document.querySelectorAll('.js-hotel-search-control');
  const hasOpenControls = Array.from(controls).some((control) => control.querySelector('.js-hotel-search-control-container.open'));
  const isWidgetOpen = widget && widget.classList.contains('open');

  if (hasOpenControls || isWidgetOpen) {
    controls.forEach((control) => {
      widgetClose(widget);
      controlClose(control);
    });
    if (isMobile()) {
      hotelSearchBackdropRemove();
    }
  }
}

const hotelSearchWidget = window.document.querySelector('.js-hotel-search');
if (hotelSearchWidget) {
  const destinationProperties = hotelSearchWidget.querySelectorAll('.js-destination-property');
  destinationProperties.forEach((property) => {
    property.addEventListener('click', (event) => {
      event.preventDefault();
      const { target } = event;
      const control = target.closest('.js-hotel-search-control');
      if (!control) return;
      const trigger = control.querySelector('.js-hotel-search-control-trigger');
      if (trigger) {
        trigger.textContent = target.textContent.trim();
      }
      const link = property.href;
      if (link) {
        addLink(control, link);
      }
      controlClose(control);
      widgetClose(widget);
      if (isMobile()) {
        hotelSearchBackdropRemove();
      }
      updateCatalogOverflowState(hotelSearchWidget, '.js-hotel-search-control-container');
    });
  });
}

document.addEventListener('click', (event) => {
  const { target } = event;

  if (target.classList.contains('js-control-back')
    || target.closest('.js-control-back')) {
    const control = target.closest('.js-hotel-search-control');
    if (control) {
      controlClose(control);
      widgetClose(widget);
      if (isMobile()) {
        hotelSearchBackdropRemove();
      }
    }
  }
});

const controlTriggers = document.querySelectorAll('.js-hotel-search-control-trigger');
controlTriggers.forEach((trigger) => {
  function openSelect(event) {
    const { target } = event;
    const control = target.closest('.js-hotel-search-control');
    const dataInput = target.dataset.input;
    const input = control.querySelector(`.${dataInput}`);
    controlCloseAll(widget);
    controlOpen(control);

    if (!isIOS || !isMobile()) {
      focusOn(input);
    }

    if (!widget.classList.contains('open')) {
      widgetOpen(widget);
    }
    if (isMobile()) {
      hotelSearchBackdropAdd();
    }

    updateCatalogOverflowState(widget, '.js-hotel-search-control-container');
  }

  trigger.addEventListener('click', openSelect);

  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openSelect(event);
    }
  });
});

window.document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeHotelSearchWidget();
  }
});

window.document.addEventListener('click', (event) => {
  const { target } = event;
  const closest = target.closest('.js-hotel-search-control, .js-hotel-search-widget');
  if (closest === null) {
    closeHotelSearchWidget();
  }
});

if (isIOS) {
  document.addEventListener('touchmove', (e) => {
    const hotelSearch = window.document.querySelector('.hotel-search');
    if (hotelSearch && hotelSearch.classList.contains('backdrop')) {
      const controlContainer = e.target.closest('.c-control__container');
      const catalogContainer = e.target.closest('.c-destination__catalog-container');

      if (catalogContainer && !catalogContainer.classList.contains('no-scroll')) {
        const canScroll = catalogContainer.scrollHeight > catalogContainer.clientHeight;
        if (canScroll) {
          return;
        }
      }

      if (controlContainer && !controlContainer.classList.contains('no-scroll')) {
        const canScroll = controlContainer.scrollHeight > controlContainer.clientHeight;
        if (canScroll) {
          return;
        }
      }

      e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('focusin', (event) => {
    if (event.target.matches('input[type="text"], input[type="search"], textarea')) {
      const hotelSearch = window.document.querySelector('.hotel-search');
      if (hotelSearch && hotelSearch.classList.contains('backdrop')) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, 100);
      }
    }
  });

  document.addEventListener('focusout', (event) => {
    if (event.target.matches('input[type="text"], input[type="search"], textarea')) {
      setTimeout(() => {
        const hotelSearch = window.document.querySelector('.hotel-search');
        if (hotelSearch && hotelSearch.classList.contains('backdrop')) {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;

          if (!isBodyFixed()) {
            fixedBodyStyleAddAll();
          }
        }
      }, 300);
    }
  });
}

window.addEventListener('resize', () => {
  const openedControl = window.document.querySelector('.js-hotel-search-control-container.open');

  if (!isMobile()) {
    hotelSearchBackdropRemove();
    fixedBodyStyleRemoveAll();
  }

  if (!openedControl) {
    widgetClose(widget);
    if (isMobile()) {
      hotelSearchBackdropRemove();
    }
  } else if (widget.classList.contains('open') && isMobile()) {
    hotelSearchBackdropAdd();
  }

  updateCatalogOverflowState(widget, '.js-hotel-search-control-container');
});

document.addEventListener('input', (event) => {
  const { target } = event;
  if (target && target.classList && target.classList.contains('js-catalog-search')) {
    updateCatalogOverflowState(widget, '.js-hotel-search-control-container');
  }
});
